import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import SweetAlert from "react-bootstrap-sweetalert";
import { useHistory } from "react-router-dom";

// UI Components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";

// Styles
import styles from "assets/jss/material-dashboard-pro-react/views/pricingPageStyle.js";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";
import style from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";

const useStyles = makeStyles(styles);
const useAlertStyles = makeStyles(style);
const useSharedStyles = makeStyles({
    cardTitle,
    centerContent: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
    },
});

export default function SearchWhatsApps() {
    const classes = useStyles();
    const sharedClasses = useSharedStyles();
    const history = useHistory();
    const alertClasses = useAlertStyles();

    const [mobile, setMobile] = useState("");
    const [mobileErr, setMobileErr] = useState("");
    const [countryCode, setCountryCode] = useState("in");
    const [countryName, setCountryName] = useState("India");
    const [dialCode, setDialCode] = useState("91");

    const [alert, setAlert] = useState(false);
    const [alertMsg, setAlertMsg] = useState("");
    const [alertType, setAlertType] = useState("success");

    const handlePhoneChange = (value, countryData) => {
        setMobile(value);
        setMobileErr("");

        if (countryData) {
            setCountryCode(countryData.countryCode);
            setDialCode(countryData.dialCode);
            setCountryName(countryData.name);
        }
    };

    const SubmitSearchClient = () => {
        if (!mobile) {
            setMobileErr("Please enter a mobile number.");
            return;
        }

        const numericMobile = mobile.replace(/\D/g, "");
        let nationalNumber = numericMobile;

        if (numericMobile.startsWith(dialCode)) {
            nationalNumber = numericMobile.slice(dialCode.length);
        }

        const { min = 5, max = 15 } = countryPhoneLengths[countryCode.toLowerCase()] || {};

        if (nationalNumber.length < min || nationalNumber.length > max) {
            setAlertMsg(`Please enter a valid mobile number (${min}-${max} digits) for ${countryName}.`);
            setAlertType("error");
            setAlert(true);
            return;
        }

        const message = `Hi there! 👋
I'm Indian Bangles Manufacture & Wholesale.
Could you please provide more details? Thanks!

More info: https://indianbangles.in
Please get back to me. Thanks!`;

        const encodedMessage = encodeURIComponent(message);
        const whatsAppLink = `https://api.whatsapp.com/send?phone=${mobile}&text=${encodedMessage}&app_absent=0`;

        window.open(whatsAppLink, "_blank");

        setAlertMsg(`Searching WhatsApp for: +${mobile} (${countryName})`);
        setAlertType("success");
        setAlert(true);
    };

    const hideAlert = () => {
        setAlert(false);
        if (alertType === "success") {
            window.location.reload();
        }
    };

    return (
        <div className={classes.container}>
            <GridContainer justify="center">
                <GridItem xs={8} sm={8} md={8}>
                    <Card>
                        <CardBody className={sharedClasses.centerContent}>
                            <h4>Search Client WhatsApp</h4>
                            <form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    SubmitSearchClient();
                                }}
                                style={{ width: "100%", maxWidth: "350px" }}
                            >
                                <PhoneInput
                                    country={countryCode}
                                    value={mobile}
                                    onChange={handlePhoneChange}
                                    enableAreaCodes
                                    disableCountryGuess
                                    countryCodeEditable={false}
                                    inputStyle={{ width: "100%" }}
                                    required
                                />
                                <br />
                                <div>
                                    <span style={{ color: "red" }}>{mobileErr}</span>
                                </div>
                                <br />
                                <Button
                                    color="rose"
                                    type="submit"
                                    className={classes.updateProfileButton}
                                    // fullWidth
                                >
                                    Search Client WhatsApp
                                </Button>
                            </form>
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>

            {alert && (
                <SweetAlert
                    title={alertType === "error" ? "Error" : "Success"}
                    success={alertType === "success"}
                    error={alertType === "error"}
                    onConfirm={hideAlert}
                    confirmBtnCssClass={
                        alertType === "success"
                            ? alertClasses.button + " " + alertClasses.success
                            : alertClasses.button + " " + alertClasses.danger
                    }
                >
                    {alertMsg}
                </SweetAlert>
            )}
        </div>
    );
}

const countryPhoneLengths = {
    in: { min: 10, max: 10 },
    us: { min: 10, max: 10 },
    ae: { min: 9, max: 9 },
    pk: { min: 10, max: 10 },
    bd: { min: 10, max: 10 },
    gb: { min: 10, max: 10 },
    ca: { min: 10, max: 10 },
    au: { min: 9, max: 9 },
    sa: { min: 9, max: 9 },
    ng: { min: 10, max: 10 },
    ke: { min: 9, max: 9 },
    za: { min: 9, max: 10 },
    de: { min: 8, max: 11 },
    fr: { min: 9, max: 10 },
    it: { min: 9, max: 10 },
    es: { min: 9, max: 9 },
    cn: { min: 11, max: 11 },
};
